import { Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPortalSourcingEventsQuery } from "../../../../autogen/bff-api";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";

const DISPLAY_LIMIT = 6;

export const OpenProcurementsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();

  const { data, isLoading, isError } = useGetPortalSourcingEventsQuery({ limit: DISPLAY_LIMIT });
  const events = data?.events ?? [];

  return (
    <HomePanel titleKey="Open procurements" seeAllTo={urls.v2.supplier.procurements} isLoading={isLoading} isError={isError} isEmpty={events.length === 0} emptyKey="No open procurements right now">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("Buyer")}</Th><Th>{t("Deadline")}</Th></Tr></Thead>
        <Tbody>
          {events.map((event) => (
            <Tr key={event.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigate(urls.v2.supplier.procurement.go(event.id))}>
              <Td fontWeight="medium" color="smText">{event.title || t("Untitled")}</Td>
              <Td><Text fontSize="sm" color="smMuted">{event.buyerName}</Text></Td>
              <Td>
                <Text fontSize="sm" color="smMuted">
                  {event.bidSubmissionDeadline ? displayDate(event.bidSubmissionDeadline) : "—"}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
